import { ChevronLeft, X } from 'lucide-react'
import type { ReactNode } from 'react'
import { Button } from '@/shared/ui/button'

interface SidePanelHeaderProps {
  title: string
  icon: ReactNode | null
  onClose: () => void
  onBack?: () => void
  canGoBack?: boolean
}

export function SidePanelHeader({
  title,
  onClose,
  icon,
  onBack,
  canGoBack = false
}: SidePanelHeaderProps) {
  return (
    <div className="sticky top-0 z-10 flex shrink-0 items-center gap-1.5 border-b border-accent bg-neutral-50 px-1 py-2 dark:bg-neutral-950/40">
      <Button variant="ghost" size="icon" className="h-7 w-7 shrink-0" onClick={onClose}>
        <X className="h-4 w-4" />
      </Button>
      <div className="flex min-w-0 items-center gap-1">
        {canGoBack && (
          <Button variant="ghost" size="icon" className="h-7 w-7 shrink-0" onClick={onBack}>
            <ChevronLeft className="h-4 w-4" />
          </Button>
        )}
        {icon && (
          <span className="flex size-5 aspect-square items-center justify-center gap-2 rounded bg-accent p-1 text-accent-foreground [&_svg]:pointer-events-none [&_svg]:size-3.5 [&_svg]:shrink-0">
            {icon}
          </span>
        )}
        <h3 className="truncate text-sm font-semibold text-accent-foreground">{title}</h3>
      </div>
    </div>
  )
}
